<template>
  <basic-page>
    <a-col :span="24" slot="header">
      <a-row class="relation-list">
        <a-col :xs="17" :sm="18" :md="21" :lg="22" :xl="22" style="text-align: left;">
          <span>
            <a @click="changeAds($event, 0, 0)" class="ads-title" style="color: #1890ff">
              产品推广
              <a-icon type="sound"/>
            </a>
          </span>
          <span v-for="(item, index) in adsList" :key="index">
            <a @click="changeAds($event, item, index + 1)" class="ads-title">
              {{item.title}}
              <a-icon type="sound"/>
            </a>
          </span>
          <span v-if="adsList.length == 0">
            没有可用的推广模板, 请先进行推广设置。
          </span>
        </a-col>
        <a-col :xs="7" :sm="6" :md="3" :lg="2" :xl="2" style="text-align: right;">
          <a-icon v-if="isAds==false" type="plus-circle" @click="newItem"   
            style="fontSize: 16px;color: gray;vertical-align: middle;" class="ads-title"
          />
          <a-icon v-if="isAds==false":component="ShareIcon" 
            @click="showSharePanel" style="fontSize: 16px;vertical-align: middle;" class="ads-title"
          />
          <a-icon v-if="isAds==false" type="delete" 
            @click="deleteList" style="fontSize: 16px;color: gray;vertical-align: middle;"   class="ads-title"
          />
          <router-link to="/uc/adsp" class="ads-title">
            <a-tooltip title="推广设置"><a-icon type="setting" style="vertical-align: middle;"/></a-tooltip>
          </router-link>
        </a-col>
      </a-row>
    </a-col>

    <a-row slot="content">
      <a-row>
        <ads-search v-if="isAds" @search="search" :postdata="postdata" :result="result"/>
        <sale-center v-else="" @selectedlist="selectItem" @emitlinklist="watchLink" :filelist="fileList" :linklist="linkList" :key="refresh"/>
        <a-modal v-model="sharepanel" title="新建分享" :footer="null" 
          width="350px">
          <a-form :form="shareform">
            <a-form-item  
                :label-col=  "{sm: { span: 6  }, md: { span: 5 }, lg: { span: 3 }, xl: { span: 3 }, xxl: {span: 4}}" 
                :wrapper-col="{sm: { span: 18 }, md: { span: 19}, lg: { span: 21}, xl: { span: 21}, xxl: {span: 20}}" 
                style="margin-bottom: 8px; text-align: right;">
              <a-input placeholder="请输入分享标题" v-decorator="[ 'title', {rules: [{ required: true, message: '请输入分享标题！'}]} ]" style="margin-bottom: 12px;"/>
              <a-input placeholder="请输入分享说明" v-decorator="[ 'desc', {rules: [{ required: false, message: '请输入分享说明！'}]} ]"/>
            </a-form-item>
            <a-form-item style="text-align: center; margin-bottom: 12px;">
              <a-button type="primary" @click="shareItem">分享</a-button>
            </a-form-item>
          </a-form>
        </a-modal>
        <a-modal v-model="productpanel" title="新建产品说明" :footer="null">
              <a-row style="margin: 8px 0px;">
                <a-col :span="24" >
                  <a-upload
                    name="avatar"
                    listType="picture-card"
                    class="avatar-uploader"
                    :showUploadList="false"
                    action=""
                    :beforeUpload="beforeUpload"
                    @change="handleImg"
                  >
                    <img v-if="imageUrl" :src="imageUrl" alt="avatar" style="width: 100%;"/>
                    <div v-else>
                        <a-icon :type="loading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">点击上传图片</div>
                    </div>
                  </a-upload>
                </a-col>
                <a-col>
                  <a-textarea v-model="img_content"  rows="6" placeholder="产品说明..."></a-textarea>
                </a-col >
              </a-row>
              <a-row style="margin: 8px 0px;text-align: center;">
                <a-button @click="newPost">保存</a-button>
              </a-row>
        </a-modal>

      </a-row>
    </a-row>

    <!--a-col :span="24" slot="loadmore" v-if="result.length > 0">
      <a-row>
        <a-button @click="loadMore">加载更多</a-button>
      </a-row>
    </a-col -->
  </basic-page>
</template>

<script>

function getBase64 (img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

import BasicPage from '@/layout/BasicPage.vue'
import AdsSearch from '@/com/Ads/AdsSearch.vue'
import SaleCenter from '@/com/Ads/SaleCenter.vue'
import ShareIcon from '@/assets/img/ShareIcon.vue';

import {BACKEND_API_PREFIX, SHARE_LINK_HOST} from '@/util/config';

import reqwest from 'reqwest'

export default {
  name: 'Ads',
  data() {
    return {
      server: SHARE_LINK_HOST,
      ShareIcon,
      tab: 'ads',
      type: '',
      isAds: false,
      postdata: {},
      result: [],
      adsList: [],
      fileList: [],
      linkList: [],
      selectedList: [],
      imgList: [],
      loading: false,
      imageUrl: '',
      img_content: '',
      productpanel: false,
      sharepanel: false,
      shareform: this.$form.createForm(this),
      refresh: 0,
    }
  },
  components: {
    BasicPage,
    SaleCenter,
    AdsSearch,
  },
  methods: {
    selectItem: function(list) {
      this.selectedList = list;
    },
    watchLink: function(list) {
      this.linkList = list;
    },
    newItem () {
      this.productpanel = true;
    },
    handleImg (info) {
      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl
          this.loading = false
        })
      if (info.file.status === 'done') {
        // Get this url from response in real world.
      }
    },
    beforeUpload (file) {
      this.imgList = [file];
    },
    handleImgContent () {
      this.img_content= info;
    },
    newPost () {
      if (!this.imageUrl) {
           this.$message.info("请上传产品图片！");
           return;
        }
      if (!this.img_content) {
           this.$message.info("请上传产品图片！"); 
           return;
        }
      const formData = new FormData();

      this.imgList.forEach((file) => {
        formData.append('files[]', file);
      });
      formData.append('task', "ADD_CARD")
      formData.append('content', this.img_content)
      formData.append('agent_key', this.$store.getters.getAgentkey())
      formData.append('access_token', this.$store.getters.getToken())
        
      let that = this;
      reqwest({
        url: BACKEND_API_PREFIX + 'ads-card',
        method: 'post',
        processData: false,
        data: formData,
        success: (resp) => {
          that.imgList = []
          that.uploading = false  
          let rsp = JSON.parse(resp);
          if (rsp.ret == 200){
            that.$message.success('上传成功！');
            let item={id: rsp.data.id, img: that.imageUrl, content: that.img_content}
            if(that.fileList < 1){
              that.fileList.push(item);
            }else{
              that.fileList.unshift(item);
            }
            that.imageUrl= "";
            that.img_content= "";
            that.selectedList = [];
            that.refresh += 1;
          } else{
            that.$message.error('上传失败！');
          }
        }, error: () => {
          that.uploading = false
          that.$message.error('上传失败！');
        }
      })
    },
    deleteList (list) {
      if(this.selectedList.length < 1){
        this.$message.info("请选选择待删除的产品说明！");
        return
      }
      let ids = this.selectedList;
      let postdata = {
        ids: ids,
        task: "DELETE_CARD"
      }
      let that = this;
      that.post('ads-card', postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.$message.success("删除成功！");
            let list = that.fileList;
            let dlist = that.selectedList;
            let newlist = [];
            for (let i = 0; i < dlist.length; i++) {
              for (let j = 0; j < list.length; j++) {
                if (dlist[i] != list[j].id) {
                  newlist.push(list[j]);
                }
              }
              list = newlist;
              newlist = [];
            }
            that.fileList = list;
            that.selectedList = [];
            that.refresh += 1;
          } else {
            that.$message.error(data.msg);
          }
        }).catch(function (e) {
          that.$message.error("fail");
      });
    },
    showSharePanel() {
      this.sharepanel = true;
    },
    shareItem () {
      let e = false;
      this.shareform.validateFields((err, values) => {
        if (err) {
          e = true;
          return;
        }
      });
      if (e) {
        return;
      }
      let list = this.selectedList;
      let postdata = {
        ids: list,
        title: this.shareform.getFieldValue("title"),
        desc: this.shareform.getFieldValue("desc"),
        task: "GENERATE_CARD"
      }
      let that = this;
      that.post('ads-card', postdata)
        .then(function(data) {
          if (data.ret == 200) {
            let href = 'http://' + server + '/card/' + that.$store.getters.getAgentkey() + '/' + data.data.id + '.html';
            window.open(href);
            that.linkList.unshift({id: data.data.id, agent_key: that.$store.getters.getAgentkey(), title: that.shareform.getFieldValue("title")});
            that.selectedList = [];
            that.sharepanel = false;
            that.$message.success("分享成功！");
            that.refresh += 1;
          } else {
            that.$message.error("分享失败！");
          }
        }).catch(function (e) {
          console.log(e)
          that.$message.error("分享失败！");
      });
    },
    changeAds: function(e, item, index) {
      let root = e.target.parentNode.parentNode
      for (let i = 0; i < root.childNodes.length && i < (this.adsList.length + 1); i++) {
        if ( i == index ) {
          root.childNodes[i].childNodes[0].style.color = "#1890ff"
        } else {
          root.childNodes[i].childNodes[0].style.color = "gray"
        }
      }
      if (index == 0) {
        this.isAds = false;
        this.refres += 1;
      } else {
        this.isAds = true;
        let postdata = {}
        let page = 1;
        postdata["id"] = item.id
        postdata["title"] = item.title
        postdata["page"] = page
        postdata["from"] = (page - 1) * 20
        postdata["to"] = page * 20
        postdata["content"] = item.desc
        postdata["task"] = "NEWS_SEARCH"
        postdata["api-path"] = "news"
        let that = this
        that.postdata = postdata
        let loading = that.$message.loading("搜索中...", 0);
        that.post('news', that.postdata)
          .then(function(data) {
            setTimeout(loading, 0);
            that.$store.commit('updatepostdata', {post: that.postdata, tab: 'ads'});
            that.$store.commit('updateresult', {result: data.data, tab: 'ads'});
            //console.log("data retrieved:"); 
            //console.log(data.data);
            that.result = data.data
          }).catch(function (e) {
            setTimeout(loading, 0);
            that.$message.error("查询失败")
        })
      }
    },
    search: function(postdata, result) {
      this.posdata = postdata
      this.result = result
    },
    loadMore: function() {
      this.postdata = this.$store.getters.getPostdata()
      let currentPage = this.postdata.page + 1;
      this.postdata.page = currentPage;
      let from = (currentPage - 1) * 20;
      let to = (currentPage) * 20;
      this.postdata["from"] = from;
      this.postdata["to"] = to;
      let that = this;
      let loading = that.$message.loading("搜索中...", 0);
      that.post(that.postdata["api-path"], that.postdata)
        .then(function(data) {
          for(let i = 0; i < data.data.length; i++) {
            that.result.push(data.data[i]);
          }
          setTimeout(loading, 0);
          that.$store.commit('updatepostdata', {post: that.postdata, tab: 'ads'});
          that.$store.commit('updateresult', {result: that.result, tab: 'ads'});
        }).catch(function (e) {
          setTimeout(loading, 0);
          that.$message.error("查询失败");
      });
    }
  },
  created() {
    this.$store.commit('changetab', this.tab)
    let postdata = {
      task: "SEARCH_TEMPLATE",
      "api-path": "ads"
    }
    let that = this;
    that.post(postdata["api-path"], postdata)
      .then(function(data) {
        if (data.ret == 200) {
          that.adsList = data.data;
          let item = that.adsList[0]
          let postdata = {}
          let page = 1;
          postdata["id"] = item.id
          postdata["title"] = item.title
          postdata["page"] = page
          postdata["from"] = (page - 1) * 20
          postdata["to"] = page * 20
          postdata["content"] = item.desc
          postdata["task"] = "NEWS_SEARCH"
          postdata["api-path"] = "news"
          that.postdata = postdata
          let loading = that.$message.loading("搜索中...", 0);
          that.post('news', that.postdata)
            .then(function(data) {
              setTimeout(loading, 0);
              that.$store.commit('updatepostdata', {post: that.postdata, tab: 'ads'});
              that.$store.commit('updateresult', {result: data.data, tab: 'ads'});
              that.result = data.data
            }).catch(function (e) {
              setTimeout(loading, 0);
              that.$message.error("查询失败")
          })
        }
      }).catch(function (e) {
    });
    postdata = {
      'task':'LIST_CARD'
    };
    that.post('ads-card', postdata)
    .then(function(data){
      if(data.ret ==200){
        that.fileList=data.data;
      }
    }).catch(function (e) {
    });
    postdata = {
      'task':'LIST_CARD_LINK'
    };
    that.post('ads-card', postdata)
      .then(function(data){
        if(data.ret ==200){
          that.linkList = data.data;
        }
    }).catch(function(e){
      console.log(e);
    });
  }
}
</script>

<style scoped>
  .relation-list {
    text-align: left; 
    padding: 8px; 
    border-bottom: 1px solid #d1d5da;
    background-color: #f5f6f5 /*#f1f8ff*/;
  }
  .ads-title {
    display: inline-block;
    color: gray;
    padding: 0px 4px;
  }
  .ads-title:hover {
    color: #1890ff;
  }
  /deep/.ant-upload.ant-upload-select-picture-card {
    border: 1px dashed #d9d9d9;
    width: 100%;
    height: 150px;
  }
</style>
